import { withChartLayout } from 'components/common';
import OvertAggressionScale from 'components/features/chart/special-charts/overt-aggression-scale/OvertAggressionScale';

const OvertAggressionScalePage = withChartLayout('Overt Aggression Scale')(OvertAggressionScale);
export default OvertAggressionScalePage;
